// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { useCaseShell } from './CaseShellContext';
import styles from './ShellNotices.module.css';

/** The case-wide notices, in reading order; empty when all is well. */
export function useShellNotices(): string[] {
  const { role, unreachable, health } = useCaseShell();
  const notices: string[] = [];
  if (unreachable) notices.push('Serveren svarer ikke — ændringer gemmes ikke.');
  else if (health?.project.open === false) notices.push('Serveren kunne ikke åbne projektets database.');
  if (role === 'viewer') notices.push('Læseadgang: du kan se sagen, men ikke ændre den.');
  return notices;
}

/**
 * The case-wide notices, said once above every screen: a viewer's read-only
 * access (S3 review M9), an unreachable server, a database the server could
 * not open. `chips` are rounded chips for a floating stack (the Bygning
 * shell positions the stack); `inline` is a strip at the top of the
 * ToolFrame's content.
 */
export function ShellNotices({ variant }: { variant: 'chips' | 'inline' }) {
  const notices = useShellNotices();
  if (notices.length === 0) return null;
  return (
    <div className={variant === 'chips' ? styles.chips : styles.inline} role="status">
      {notices.map((n) => (
        <p key={n} className={styles.notice}>
          {n}
        </p>
      ))}
    </div>
  );
}
